/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var createReservation = makeEntityScaffold('SAGA.API.CREATE_RESERVATION_ENTITY', function (client, userId, body) {
  return client.reservations.create(userId, body);
});
export var cancelReservation = makeEntityScaffold('SAGA.API.CANCEL_RESERVATION_ENTITY', function (client, userId, reservationId, body) {
  return client.reservations.update(userId, reservationId, body);
}, {
  defaultKey: function defaultKey(client, userId, reservationId) {
    return reservationId;
  }
});
export var createVideoReservation = makeEntityScaffold('SAGA.API.CREATE_VIDEO_RESERVATION_ENTITY', function (client, userId, body) {
  return client.reservations.createVideoReservation(userId, body);
}, {
  defaultKey: function defaultKey(client, userId, body) {
    return body.content_id;
  }
});